import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Belgaumtokeralacabservice() {



    const cardData = {


keyword: "Belgaum to Kerala Cab Service",

headingDescription: "Belgaum Taxi Service provides reliable Belgaum to Kerala cab services for family vacations, honeymoon tours, corporate travel, pilgrimage trips, medical visits, holiday packages, and long-distance outstation journeys. Whether you require a one-way taxi or a round-trip cab from Belgaum to Kerala, we offer safe, comfortable, and affordable travel with experienced chauffeurs and well-maintained vehicles. Choose from Sedan, Ertiga, SUV, Innova, Innova Crysta, Tempo Traveller, and premium cars based on your travel requirements. We provide doorstep pickup, flexible travel schedules, transparent pricing, easy online booking, and 24/7 customer support to ensure a smooth and enjoyable journey. Belgaum Taxi Service covers all major destinations across Kerala, including Kochi, Munnar, Alleppey, Thekkady, Wayanad, Kovalam, Trivandrum, Kozhikode, Kannur, and other popular tourist destinations, making your long-distance journey comfortable and hassle-free.",

topPlaces: [
  {
    title: "Munnar",
    description: "Munnar is one of Kerala's most famous hill stations, known for its tea plantations, misty mountains, waterfalls, scenic viewpoints, and pleasant climate throughout the year."
  },
  {
    title: "Alleppey",
    description: "Alleppey is renowned for its peaceful backwaters, traditional houseboats, canals, and beautiful landscapes, making it a must-visit destination for travelers."
  },
  {
    title: "Kochi",
    description: "Kochi is Kerala's commercial capital, famous for Fort Kochi, Marine Drive, Chinese Fishing Nets, shopping streets, heritage attractions, and modern city life."
  },
  {
    title: "Thekkady",
    description: "Thekkady is home to the Periyar Wildlife Sanctuary, offering wildlife safaris, boating, spice plantations, and lush green forests for nature lovers."
  },
  {
    title: "Wayanad",
    description: "Wayanad is a picturesque hill district known for waterfalls, caves, wildlife sanctuaries, trekking trails, and coffee plantations."
  },
  {
    title: "Kovalam",
    description: "Kovalam is one of Kerala's most popular beach destinations, featuring golden beaches, luxury resorts, lighthouse views, and water sports activities."
  },
  {
    title: "Thiruvananthapuram",
    description: "Thiruvananthapuram, the capital of Kerala, is known for the Sree Padmanabhaswamy Temple, museums, cultural attractions, beaches, and government institutions."
  },
  {
    title: "Kozhikode",
    description: "Kozhikode is a historic coastal city famous for beautiful beaches, Malabar cuisine, shopping markets, and rich cultural heritage."
  },
  {
    title: "Kannur",
    description: "Kannur is known for its pristine beaches, ancient forts, Theyyam performances, and scenic coastal beauty, making it a popular tourist destination."
  },
  {
    title: "Varkala",
    description: "Varkala is a unique coastal destination famous for its dramatic cliffs, clean beaches, spiritual atmosphere, yoga retreats, and stunning Arabian Sea sunsets."
  }
],




"services": [
  {
    "name": "Belgaum to Kerala Cab Service",
    "description": "Book Belgaum to Kerala Cab Service for safe and comfortable long-distance travel with professional chauffeurs, clean AC Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and Mini Bus options. Enjoy fixed fares, doorstep pickup, one way and round trip services, sightseeing tours, family vacations, corporate travel, and 24x7 booking support."
  },
  {
    "name": "Belgaum to Kerala Taxi Service",
    "description": "Choose Belgaum to Kerala Taxi Service for reliable intercity transportation with experienced drivers, transparent pricing, premium vehicles, luggage assistance, and flexible pickup schedules."
  },
  {
    "name": "Belgaum to Kerala Cab",
    "description": "Reserve Belgaum to Kerala Cab with instant online booking, AC vehicles, fixed pricing, professional chauffeurs, and comfortable travel to all major destinations across Kerala."
  },
  {
    "name": "Belgaum to Kerala Taxi",
    "description": "Travel with Belgaum to Kerala Taxi for business trips, holiday travel, family vacations, pilgrimage tours, and airport transfers with well-maintained chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Kerala Car Rental",
    "description": "Hire Belgaum to Kerala Car Rental with Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and Mini Bus vehicles for flexible outstation travel."
  },
  {
    "name": "Belgaum to Kerala Cab Booking",
    "description": "Complete Belgaum to Kerala Cab Booking online with instant confirmation, secure reservations, multiple vehicle options, and affordable travel packages."
  },
  {
    "name": "Online Belgaum to Kerala Cab Booking",
    "description": "Book Online Belgaum to Kerala Cab Booking with transparent pricing, quick confirmation, flexible pickup timings, and 24x7 customer assistance."
  },
  {
    "name": "Belgaum to Kerala One Way Cab",
    "description": "Reserve Belgaum to Kerala One Way Cab with fixed fares, direct destination drop, experienced drivers, and comfortable intercity transportation."
  },
  {
    "name": "Belgaum to Kerala Round Trip Cab",
    "description": "Choose Belgaum to Kerala Round Trip Cab with flexible return schedules, affordable pricing, premium vehicles, and reliable chauffeur-driven travel."
  },
  {
    "name": "Outstation Cab from Belgaum to Kerala",
    "description": "Book Outstation Cab from Belgaum to Kerala for long-distance travel with comfortable AC vehicles, professional chauffeurs, and customized travel plans."
  },
  {
    "name": "Belgaum to Kerala Tour Package",
    "description": "Plan your Belgaum to Kerala Tour Package with customized sightseeing, multiple destination coverage, premium vehicles, and experienced drivers."
  },
  {
    "name": "Belgaum to Kerala Innova Crysta Cab",
    "description": "Book Belgaum to Kerala Innova Crysta Cab for luxury family travel, corporate tours, group trips, spacious seating, and premium comfort."
  },
  {
    "name": "Belgaum to Kerala Ertiga Cab",
    "description": "Reserve Belgaum to Kerala Ertiga Cab for affordable six-seater travel with comfortable seating, luggage space, and reliable chauffeur service."
  },
  {
    "name": "Belgaum to Kerala Sedan Cab",
    "description": "Travel with Belgaum to Kerala Sedan Cab for economical and comfortable outstation transportation with experienced drivers."
  },
  {
    "name": "Belgaum to Kerala SUV Cab",
    "description": "Hire Belgaum to Kerala SUV Cab for family vacations, group travel, premium comfort, and long-distance road trips across Kerala."
  },
  {
    "name": "Belgaum to Kerala Tempo Traveller",
    "description": "Book Belgaum to Kerala Tempo Traveller for group tours, family vacations, corporate outings, and comfortable long-distance travel."
  },
  {
    "name": "Belgaum to Kerala Mini Bus",
    "description": "Reserve Belgaum to Kerala Mini Bus for school trips, pilgrimage tours, corporate travel, and large group transportation with experienced drivers."
  },
  {
    "name": "Best Cab Service Belgaum to Kerala",
    "description": "Experience the Best Cab Service Belgaum to Kerala with premium vehicles, professional chauffeurs, fixed pricing, and excellent customer support."
  },
  {
    "name": "Cheap Cab Belgaum to Kerala",
    "description": "Find Cheap Cab Belgaum to Kerala with affordable fares, clean AC vehicles, transparent pricing, and dependable outstation transportation."
  },
  {
    "name": "Belgaum to Kerala Taxi Fare",
    "description": "Check Belgaum to Kerala Taxi Fare with fixed pricing, affordable travel packages, multiple cab categories, and no hidden charges."
  },
  {
    "name": "Belgaum to Kerala Car Hire",
    "description": "Choose Belgaum to Kerala Car Hire with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, and luxury vehicles for comfortable travel."
  },
  {
    "name": "Belgaum to Kochi Cab",
    "description": "Book Belgaum to Kochi Cab for safe and comfortable travel with experienced chauffeurs, fixed fares, and premium AC vehicles."
  },
  {
    "name": "Belgaum to Cochin Taxi",
    "description": "Reserve Belgaum to Cochin Taxi with affordable pricing, comfortable seating, luggage assistance, and professional drivers."
  },
  {
    "name": "Belgaum to Munnar Cab",
    "description": "Travel with Belgaum to Munnar Cab for scenic hill station journeys, family vacations, honeymoon trips, and sightseeing tours."
  },
  {
    "name": "Belgaum to Wayanad Cab",
    "description": "Book Belgaum to Wayanad Cab for comfortable travel to Kerala's beautiful hill destination with clean AC vehicles and experienced chauffeurs."
  },
  {
    "name": "Belgaum to Alleppey Cab",
    "description": "Reserve Belgaum to Alleppey Cab for relaxing backwater vacations with reliable chauffeur-driven transportation and premium comfort."
  },
  {
    "name": "Belgaum to Alappuzha Taxi",
    "description": "Choose Belgaum to Alappuzha Taxi for convenient long-distance travel with fixed pricing and comfortable AC vehicles."
  },
  {
    "name": "Belgaum to Thekkady Cab",
    "description": "Book Belgaum to Thekkady Cab for wildlife tours, nature vacations, and family travel with experienced drivers."
  },
  {
    "name": "Belgaum to Kumarakom Cab",
    "description": "Travel with Belgaum to Kumarakom Cab for peaceful backwater holidays with comfortable chauffeur-driven vehicles."
  },
  {
    "name": "Belgaum to Kovalam Cab",
    "description": "Reserve Belgaum to Kovalam Cab for beach holidays with safe, comfortable, and reliable outstation transportation."
  },
  {
    "name": "Belgaum to Trivandrum Cab",
    "description": "Book Belgaum to Trivandrum Cab with premium vehicles, professional chauffeurs, and affordable outstation travel packages."
  },
  {
    "name": "Belgaum to Thiruvananthapuram Taxi",
    "description": "Choose Belgaum to Thiruvananthapuram Taxi for smooth intercity travel with transparent fares and comfortable vehicles."
  },
  {
    "name": "Belgaum to Kozhikode Cab",
    "description": "Reserve Belgaum to Kozhikode Cab with experienced drivers, AC vehicles, and reliable long-distance transportation."
  },
  {
    "name": "Belgaum to Calicut Taxi",
    "description": "Book Belgaum to Calicut Taxi with fixed pricing, online booking, and comfortable chauffeur-driven travel."
  },
  {
    "name": "Belgaum to Kannur Cab",
    "description": "Travel with Belgaum to Kannur Cab for family vacations, business travel, and comfortable outstation journeys."
  },
  {
    "name": "Belgaum to Thrissur Cab",
    "description": "Choose Belgaum to Thrissur Cab for safe travel with premium vehicles, professional chauffeurs, and transparent pricing."
  },
  {
    "name": "Belgaum to Guruvayur Cab",
    "description": "Book Belgaum to Guruvayur Cab for pilgrimage travel with reliable drivers, clean vehicles, and comfortable transportation."
  },
  {
    "name": "Belgaum to Palakkad Cab",
    "description": "Reserve Belgaum to Palakkad Cab for affordable and comfortable outstation travel with fixed fares and experienced drivers."
  },
  {
    "name": "Belgaum to Vagamon Cab",
    "description": "Travel with Belgaum to Vagamon Cab for hill station holidays, scenic road trips, and relaxing family vacations."
  },
  {
    "name": "Belgaum to Athirappilly Cab",
    "description": "Book Belgaum to Athirappilly Cab for waterfall tours, sightseeing trips, and premium chauffeur-driven travel."
  },
  {
    "name": "Belgaum to Bekal Cab",
    "description": "Reserve Belgaum to Bekal Cab for beach holidays, fort sightseeing, family vacations, and comfortable long-distance journeys."
  }
],

"tableData": [
  ["Belgaum to Kerala Cab Service", "Belgaum to Kerala Taxi Service"],
  ["Belgaum to Kerala Cab", "Belgaum to Kerala Taxi"],
  ["Belgaum to Kerala Car Rental", "Belgaum to Kerala Cab Booking"],
  ["Online Belgaum to Kerala Cab Booking", "Belgaum to Kerala One Way Cab"],
  ["Belgaum to Kerala Round Trip Cab", "Outstation Cab from Belgaum to Kerala"],
  ["Belgaum to Kerala Tour Package", "Belgaum to Kerala Innova Crysta Cab"],
  ["Belgaum to Kerala Ertiga Cab", "Belgaum to Kerala Sedan Cab"],
  ["Belgaum to Kerala SUV Cab", "Belgaum to Kerala Tempo Traveller"],
  ["Belgaum to Kerala Mini Bus", "Best Cab Service Belgaum to Kerala"],
  ["Cheap Cab Belgaum to Kerala", "Belgaum to Kerala Taxi Fare"],
  ["Belgaum to Kerala Car Hire", "Belgaum to Kochi Cab"],
  ["Belgaum to Cochin Taxi", "Belgaum to Munnar Cab"],
  ["Belgaum to Wayanad Cab", "Belgaum to Alleppey Cab"],
  ["Belgaum to Alappuzha Taxi", "Belgaum to Thekkady Cab"],
  ["Belgaum to Kumarakom Cab", "Belgaum to Kovalam Cab"],
  ["Belgaum to Trivandrum Cab", "Belgaum to Thiruvananthapuram Taxi"],
  ["Belgaum to Kozhikode Cab", "Belgaum to Calicut Taxi"],
  ["Belgaum to Kannur Cab", "Belgaum to Thrissur Cab"],
  ["Belgaum to Guruvayur Cab", "Belgaum to Palakkad Cab"],
  ["Belgaum to Vagamon Cab", "Belgaum to Athirappilly Cab"],
  ["Belgaum to Bekal Cab", ""]
],





whychoose: [
  {
    WhyChooseheading: "Reliable Belgaum to Kerala Cab Service",
    WhyChoosedescription: "Belgaum Taxi Service offers dependable Belgaum to Kerala cab services with experienced drivers, comfortable vehicles, and safe long-distance travel for every journey."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Belgaum",
    WhyChoosedescription: "Schedule your pickup from Belgaum Airport, Railway Station, hotels, homes, offices, or any nearby location with direct drop to your destination in Kerala."
  },
  {
    WhyChooseheading: "Comfortable Fleet for Long-Distance Travel",
    WhyChoosedescription: "Travel in Sedan, Ertiga, Innova, Innova Crysta, SUVs, or Tempo Travellers, selected according to your passenger count and luggage requirements."
  },
  {
    WhyChooseheading: "Experienced Drivers for Interstate Routes",
    WhyChoosedescription: "Our professional chauffeurs are familiar with interstate highways, ensuring a safe, smooth, and comfortable journey from Belgaum to Kerala."
  },
  {
    WhyChooseheading: "One Way & Round Trip Taxi Options",
    WhyChoosedescription: "Whether you need a one-way taxi or a flexible round-trip package, we provide travel solutions designed around your itinerary."
  },
  {
    WhyChooseheading: "Affordable Pricing with No Hidden Charges",
    WhyChoosedescription: "Enjoy transparent cab fares with competitive pricing, customized travel packages, and clear quotations before your journey begins."
  },
  {
    WhyChooseheading: "Ideal for Family, Business & Holiday Travel",
    WhyChoosedescription: "Our Belgaum to Kerala cabs are suitable for family vacations, corporate travel, pilgrimages, medical visits, and sightseeing tours."
  },
  {
    WhyChooseheading: "24/7 Booking Assistance",
    WhyChoosedescription: "Reserve your Belgaum to Kerala cab anytime with instant booking confirmation and dedicated customer support throughout your trip."
  }
]

};

const faqData = [
  {
    question: "Does Belgaum Taxi Service provide Belgaum to Kerala cab service?",
    answer: "Yes, Belgaum Taxi Service offers comfortable one-way and round-trip taxi services from Belgaum to destinations across Kerala."
  },
  {
    question: "Can I book a one-way cab from Belgaum to Kerala?",
    answer: "Yes, one-way cab services are available with convenient pickup from any location in Belgaum."
  },
  {
    question: "Which vehicles are available for Belgaum to Kerala travel?",
    answer: "Our fleet includes Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers for comfortable long-distance journeys."
  },
  {
    question: "Do you provide pickup from Belgaum Airport and Railway Station?",
    answer: "Yes, pickup is available from Belgaum Airport, Railway Station, hotels, offices, and residential areas."
  },
  {
    question: "Can I book a return cab from Kerala to Belgaum?",
    answer: "Yes, return and round-trip taxi services are available with flexible travel schedules."
  },
  {
    question: "Is Belgaum to Kerala cab service available 24/7?",
    answer: "Yes, our taxi services are available around the clock to match your preferred travel time."
  },
  {
    question: "Are toll, state tax, and parking charges included in the fare?",
    answer: "Toll charges, state taxes, parking fees, and other applicable charges are generally billed separately unless mentioned in the confirmed quotation."
  },
  {
    question: "Can I travel to any city in Kerala?",
    answer: "Yes, we provide taxi services to major Kerala destinations including Kochi, Munnar, Wayanad, Kozhikode, Kannur, Thrissur, Alleppey, Thekkady, Trivandrum, and more."
  },
  {
    question: "Is this service suitable for family and corporate travel?",
    answer: "Yes, our spacious and well-maintained vehicles are ideal for family holidays, business trips, group tours, and long-distance travel."
  },
  {
    question: "How can I book a Belgaum to Kerala Cab Service?",
    answer: "Share your pickup location, Kerala destination, travel date, passenger details, and preferred vehicle to receive an instant quotation and booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Ramesh Gowda",
    feedback: "Our journey from Belgaum to Kerala was comfortable and well-organized. The driver was professional, the cab was spotless, and the long-distance trip was enjoyable from beginning to end.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Deepa Nair",
    feedback: "Belgaum Taxi Service made our family trip completely stress-free. The vehicle was spacious, the booking process was smooth, and the driver ensured a safe and pleasant journey throughout.",
    rating: 5
  }
];







    const Images = [
        { place: "/images/keyword/1.jpg", text: "Cab Service in Belgaum", link: "Cab-Service-in-Belgaum" },
        { place: "/images/keyword/2.jpg", text: "Belgaum Taxi Service", link: "Belgaum-Taxi-Service" },
        { place: "/images/keyword/3.jpg", text: "Belgaum to Goa Cab", link: "Belgaum-to-Goa-Cab" },
        { place: "/images/keyword/4.jpg", text: "Belgaum to Mahabaleshwar Cab", link: "Belgaum-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Belgaum to Kerala Cab Service", link: "Belgaum-to-Kerala-Cab-Service" },
        { place: "/images/keyword/6.jpg", text: "Goa to Belgaum Cab", link: "Goa-to-Belgaum-Cab" },
        { place: "/images/keyword/7.jpg", text: "Belgaum to Mumbai Cab", link: "Belgaum-to-Mumbai-Cab" },
        { place: "/images/keyword/8.jpg", text: "Belgaum to Bangalore Cab", link: "Belgaum-to-Bangalore-Cab" },
        { place: "/images/keyword/9.jpg", text: "Goa Cab Service", link: "Goa-Cab-Service" },
        { place: "/images/keyword/10.jpg", text: "Taxi Service in Goa", link: "Taxi-Service-in-Goa" },
        { place: "/images/keyword/11.jpg", text: "Cheapest Cab Service in Goa", link: "Cheapest-Cab-Service-in-Goa" },
        { place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Belgaum", link: "Corporate-Cab-Services-in-Belgaum" },
        { place: "/images/keyword/13.jpg", text: "Innova Crysta Rent in Belgaum", link: "Innova-Crysta-Rent-in-Belgaum" },
        { place: "/images/keyword/14.jpg", text: "Ertiga on Rent in Belgaum", link: "Ertiga-on-Rent-in-Belgaum" },
        { place: "/images/keyword/15.jpg", text: "Tempo Traveller Rent in Belgaum", link: "Tempo-Traveller-Rent-in-Belgaum" },
        { place: "/images/keyword/16.jpg", text: "Mini Bus Rental Belgaum", link: "Mini-Bus-Rental-Belgaum" },
        { place: "/images/keyword/17.jpg", text: "Swift Dzire on Rent in Belgaum", link: "Swift-Dzire-on-Rent-in-Belgaum" },
        { place: "/images/keyword/18.jpg", text: "Urbania on Rent in Belgaum", link: "Urbania-on-Rent-in-Belgaum" },
        { place: "/images/keyword/19.jpg", text: "Wedding Car Rental in Belgaum", link: "Wedding-Car-Rental-in-Belgaum" },
        { place: "/images/keyword/20.jpg", text: "Cabs in Belgaum", link: "Cabs-in-Belgaum" },
        { place: "/images/keyword/21.jpg", text: "Belgaum to Hubli Cab", link: "Belgaum-to-Hubli-Cab" },
        { place: "/images/keyword/22.jpg", text: "Belgaum to Dharwad Cab", link: "Belgaum-to-Dharwad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Belgaum to Kolhapur Cab", link: "Belgaum-to-Kolhapur-Cab" },
        { place: "/images/keyword/24.jpg", text: "Belgaum Airport Cab Service", link: "Belgaum-Airport-Cab-Service" },
        { place: "/images/keyword/25.jpg", text: "Belgaum to Bagalkot Cab", link: "Belgaum-to-Bagalkot-Cab" },
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Belgaum to Kerala Cab Service",
  "image": "https://www.belgaumtaxiservice.com/assets/images/belgaum-to-kerala-cab-service.webp",
  "description":
    "Book Belgaum to Kerala Cab Service with Belgaum Taxi Service for safe, comfortable, and affordable outstation taxi services. We provide one-way and round-trip cabs from Belgaum to Kerala with Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for long-distance travel.",
  "brand": {
    "@type": "Brand",
    "name": "Belgaum Taxi Service"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.belgaumtaxiservice.com/belgaum-to-kerala-cab-service"
  }
};




    return (
        <div>


<Helmet>
  <title>Belgaum to Kerala Cab Service | Outstation Taxi | +91 8722158435</title>

  <meta
    name="description"
    content="Book Belgaum to Kerala Cab Service with Belgaum Taxi Service for reliable long-distance taxi services. Get comfortable Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs from Belgaum to Kerala for one-way, round-trip, and outstation travel available 24x7."
  />

  <meta
    name="keywords"
    content="Belgaum to Kerala Cab Service, Belgaum to Kerala Taxi Service, Belgaum to Kerala Cab, Belgaum to Kerala Taxi, Belgaum to Kerala Car Rental, Belgaum Kerala Cab, Belgaum Kerala Taxi Service, Belgaum to Kerala Outstation Cab, Belgaum to Kerala One Way Taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>








            <div className="page-headder bg-section parallaxie">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="page-header-box text-white">
                                <h1 className="text-anime-style-3 text-center text-white">
                                    {cardData.keyword}
                                </h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>













            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/5.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Belgaum Taxi Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Belgaum Taxi Service</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Belgaum Taxi Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918722158435 " className="pc-call">+91 8722158435 </a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918722158435 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918722158435 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@belgaumtaxiservice.com" className="pc-email">
                                            booking@belgaumtaxiservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Belgaum Taxi Service</strong><br />
                                            P No 30 cCTS No 7023,
                                            Sector No 9 Malmaruti Anjaneya Nagar,
                                            Belgaum, Karnataka - 590017




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Belgaumtokeralacabservice;